import { ReactNode } from 'react';

import { Box, MantineTable, MantineTableProps, Progress, TransitionElement } from 'ui';

import { useTableContext } from '../table.context';
import { TableBody } from './TableBody/TableBody';
import { TableHead } from './TableHead/TableHead';

interface TableContentProps extends MantineTableProps {
  children?: ReactNode | ReactNode[];
  stickyHeader?: boolean;
}
const TableContent = ({ children, stickyHeader = true, ...props }: TableContentProps) => {
  const { isLoading } = useTableContext();

  return (
    <>
      <TransitionElement mounted={!!isLoading} duration={350}>
        <Box pos="absolute" w={'100%'} style={{ zIndex: 4 }}>
          <Progress value={100} striped animated color="cobalt.2" />
        </Box>
      </TransitionElement>

      <MantineTable stickyHeader={stickyHeader} {...props} highlightOnHover>
        {children ? (
          children
        ) : (
          <>
            <TableHead />
            <TableBody />
          </>
        )}
      </MantineTable>
    </>
  );
};

export { TableContent };
export type { TableContentProps };
